export const noPropertiesRoute: string = "no-properties";